import {lazy} from "../../lib/lazy.js";
export const productZaloraRoutes = [
  {
    path: "/product-zalora",
    component: lazy(() => import(/* webpackChunkName: "productZaloraRoutes" */ "../../views/product-zalora/list/index.js")),
    auth: "list-product"
  }
];
